import { ResourceBaseService } from "@/core/common/resource-base/resource-base.service";
import { ApiHttpClient } from "@/core/common/http/api-http-client";
import { ConsumableHasExternalReferenceDto } from "./consumable-has-external-reference.dto";
import { CreateConsumableHasExternalReferenceDto } from "./create-consumable-has-external-reference.dto";
import { UpdateConsumableHasExternalReferenceDto } from "./update-consumable-has-external-reference.dto";
import { IRequest } from "@/interfaces/IRequest";
import { FindManyResult } from "@/core/common/resource-base/find-many-result.dto";
import { cloneDeep } from "lodash";

export class ConsumablesHaveExternalReferencesResource extends ResourceBaseService<
  ConsumableHasExternalReferenceDto,
  CreateConsumableHasExternalReferenceDto,
  UpdateConsumableHasExternalReferenceDto
> {
  protected EntityDto = ConsumableHasExternalReferenceDto;
  protected CreateEntityDto = CreateConsumableHasExternalReferenceDto;
  protected UpdateEntityDto = UpdateConsumableHasExternalReferenceDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/consumables-have-external-references");
  }

  async getByConsumable(
    consumableId: string,
    request: IRequest = {}
  ): Promise<FindManyResult<ConsumableHasExternalReferenceDto>> {
    const req = cloneDeep(request);
    if (!req.join) req.join = [];
    if (!req.join.includes("supplier")) {
      req.join.push("supplier");
    }
    if (!req.filters) req.filters = {};
    Object.assign(req.filters, { consumableId: consumableId });
    return this.findAll(req);
  }
}
